import { render, staticRenderFns } from "./PopupBudget.vue?vue&type=template&id=0b47c07c&"
import script from "./PopupBudget.vue?vue&type=script&lang=js&"
export * from "./PopupBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports